import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { Shield, User, ArrowLeft, Zap } from 'lucide-react';
import { auth } from '../utils/auth';
import { toast } from 'sonner';

const AdminQuickLogin = () => {
  const navigate = useNavigate();

  const quickLogin = async (email, password, role) => {
    try {
      const response = await auth.login(email, password);
      const userRole = response.role;
      
      toast.success(`Logget inn som ${role}`);
      
      // Route based on role
      if (userRole === 'LAWYER' || userRole === 'ADMIN' || userRole === 'TENANT_ADMIN') {
        navigate('/lexy/dashboard');
      } else {
        navigate('/cases');
      }
    } catch (error) {
      toast.error('Login feilet');
      console.error('Login error:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-6">
      
      {/* Back Button */}
      <motion.button
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        onClick={() => navigate('/lexy')}
        className="fixed top-6 left-6 flex items-center gap-2 text-white/70 hover:text-white transition-colors"
      >
        <ArrowLeft className="w-5 h-5" />
        <span className="text-sm font-medium">Tilbake</span>
      </motion.button>

      {/* Main Card */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 max-w-md w-full"
      >
        
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-slate-900 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-slate-900 mb-2">
            Quick Login
          </h1>
          <p className="text-slate-600">
            For testing og utvikling
          </p>
        </div>

        {/* Quick Login Buttons */}
        <div className="space-y-4">
          
          {/* Admin Login */}
          <motion.div
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Button
              onClick={() => quickLogin('admin@example.com', 'Password123!', 'Admin')}
              className="w-full h-16 bg-gradient-to-r from-violet-500 to-purple-600 hover:from-purple-700 hover:to-indigo-700 text-white rounded-xl shadow-lg hover:shadow-xl transition-all"
            >
              <div className="flex items-center justify-between w-full">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                    <Shield className="w-5 h-5" />
                  </div>
                  <div className="text-left">
                    <div className="font-semibold">Admin</div>
                    <div className="text-xs text-white/80">admin@example.com</div>
                  </div>
                </div>
                <ArrowLeft className="w-5 h-5 rotate-180" />
              </div>
            </Button>
          </motion.div>

          {/* Lawyer Login */}
          <motion.div
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Button
              onClick={() => quickLogin('advokat@example.com', 'Password123!', 'Advokat')}
              className="w-full h-16 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white rounded-xl shadow-lg hover:shadow-xl transition-all"
            >
              <div className="flex items-center justify-between w-full">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                    <User className="w-5 h-5" />
                  </div>
                  <div className="text-left">
                    <div className="font-semibold">Advokat</div>
                    <div className="text-xs text-white/80">advokat@example.com</div>
                  </div>
                </div>
                <ArrowLeft className="w-5 h-5 rotate-180" />
              </div>
            </Button>
          </motion.div>

        </div>

        {/* Warning Notice */}
        <div className="mt-8 p-4 bg-amber-50 border border-amber-200 rounded-lg">
          <div className="flex items-start gap-2">
            <Zap className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
            <div className="text-xs text-amber-800">
              <strong className="font-semibold">OBS:</strong> Denne siden er kun for testing og utvikling. 
              Bruk aldri i produksjon.
            </div>
          </div>
        </div>

      </motion.div>

    </div>
  );
};

export default AdminQuickLogin;
